export default {
  0: 'indigo',
  1: 'teal',
  2: 'green darken-3',
  3: 'red darken-3',
  4: 'deep-purple',
  5: 'brown'
}